import { render } from "./ImageDetail.vue?vue&type=template&id=66525872"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__